/* SHARED ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CHECK ICON — SUCCESS */
export const CheckIcon = ({ size = 14 }) => (
    <Icon size={size} width={3.4}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* CROSS ICON — ERROR */
export const ErrorIcon = ({ size = 14 }) => (
    <Icon size={size} width={3.2}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* TRIANGLE ICON — WARNING */
export const WarningIcon = ({ size = 15 }) => (
    <Icon size={size} width={2.2}>
        <path d="M12 4 2.5 20h19L12 4Z" />
        <path d="M12 10v4M12 17h.01" />
    </Icon>
)

/* INFO ICON */
export const InfoIcon = ({ size = 15 }) => (
    <Icon size={size} width={2.2}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
    </Icon>
)

/* QUESTION ICON — CONFIRMATION */
export const QuestionIcon = ({ size = 24 }) => (
    <Icon size={size} width={2.1}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.2 9.3a2.8 2.8 0 1 1 4 2.5c-.8.5-1.2 1-1.2 1.9M12 17h.01" />
    </Icon>
)

/* CLOSE ICON */
export const CloseIcon = ({ size = 14 }) => (
    <Icon size={size} width={2.4}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHEVRON LEFT ICON */
export const ChevronLeftIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.6}>
        <path d="M15 5l-7 7 7 7" />
    </Icon>
)

/* CHEVRON RIGHT ICON */
export const ChevronRightIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.6}>
        <path d="M9 5l7 7-7 7" />
    </Icon>
)

/* SERVER ICON — SERVER ERROR STATE */
export const ServerIcon = ({ size = 28 }) => (
    <Icon size={size} width={1.8}>
        <rect x="3" y="3.5" width="18" height="7" rx="2.4" />
        <rect x="3" y="13.5" width="18" height="7" rx="2.4" />
        <path d="M7 7h.01M7 17h.01M11 7h5M11 17h5" />
    </Icon>
)

/* WIFI OFF ICON — NETWORK ERROR STATE */
export const WifiOffIcon = ({ size = 28 }) => (
    <Icon size={size} width={1.8}>
        <path d="M2 2l20 20" />
        <path d="M16.7 11.1a11 11 0 0 1 2.3 1.5" />
        <path d="M5 12.6a11 11 0 0 1 5.2-2.4" />
        <path d="M10.7 5.1A16 16 0 0 1 22.6 9" />
        <path d="M1.4 9a16 16 0 0 1 4.7-2.9" />
        <path d="M8.5 16.1a6 6 0 0 1 7 0" />
        <path d="M12 20h.01" />
    </Icon>
)

/* SHIELD ICON — NO ACCESS STATE */
export const ShieldLockIcon = ({ size = 28 }) => (
    <Icon size={size} width={1.8}>
        <path d="M12 2.8l7.5 3.1v5.6c0 4.4-3.1 8.2-7.5 9.7-4.4-1.5-7.5-5.3-7.5-9.7V5.9L12 2.8Z" />
        <circle cx="12" cy="11" r="1.7" />
        <path d="M12 12.7v2.4" />
    </Icon>
)

/* KEY ICON — INVALID KEY STATE */
export const KeyIcon = ({ size = 28 }) => (
    <Icon size={size} width={1.8}>
        <circle cx="8.5" cy="8.5" r="4.5" />
        <path d="M11.7 11.7 20 20" />
        <path d="M15.9 15.9 18 13.8M18 18l2.1-2.1" />
    </Icon>
)

/* SEARCH ICON — EMPTY STATE */
export const SearchIcon = ({ size = 28 }) => (
    <Icon size={size} width={1.8}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* REFRESH ICON — RETRY BUTTONS */
export const RefreshIcon = ({ size = 15 }) => (
    <Icon size={size} width={2.4}>
        <path d="M21 12a9 9 0 1 1-9-9c2.5 0 4.9 1 6.7 2.7L21 8" />
        <path d="M21 3v5h-5" />
    </Icon>
)

/* CHEVRON DOWN ICON — THE HEADER MENU */
export const ChevronDownIcon = ({ size = 14 }) => (
    <Icon size={size} width={2.6}>
        <path d="M5 9l7 7 7-7" />
    </Icon>
)

/* BELL ICON — NOTIFICATIONS */
export const BellIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <path d="M18 8.5a6 6 0 1 0-12 0c0 5.2-2 6.5-2 6.5h16s-2-1.3-2-6.5" />
        <path d="M13.7 19a2 2 0 0 1-3.4 0" />
    </Icon>
)

/* HEADSET ICON — SUPPORT */
export const HeadsetIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <path d="M4 14h2.4a1 1 0 0 1 1 1v3.4a1 1 0 0 1-1 1H5.4A1.4 1.4 0 0 1 4 18V14Z" />
        <path d="M20 14h-2.4a1 1 0 0 0-1 1v3.4a1 1 0 0 0 1 1h1a1.4 1.4 0 0 0 1.4-1.4V14Z" />
    </Icon>
)

/* USER ICON — PROFILE */
export const UserIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4.5 20.2a7.7 7.7 0 0 1 15 0" />
    </Icon>
)

/* LOCK ICON — PASSWORD */
export const LockIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <rect x="4.5" y="10.5" width="15" height="10" rx="2.6" />
        <path d="M8.2 10.5V7.8a3.8 3.8 0 0 1 7.6 0v2.7" />
        <path d="M12 14.6v2.2" />
    </Icon>
)

/* CLOCK ICON — LOGIN HISTORY */
export const ClockIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <circle cx="12" cy="12" r="8.6" />
        <path d="M12 7.4V12l3.2 2" />
    </Icon>
)

/* LOGOUT ICON */
export const LogoutIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <path d="M14.5 4.5h3A2.5 2.5 0 0 1 20 7v10a2.5 2.5 0 0 1-2.5 2.5h-3" />
        <path d="M10 8l-4 4 4 4" />
        <path d="M6 12h9" />
    </Icon>
)

/* CAMERA ICON — AVATAR UPLOAD */
export const CameraIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <path d="M3.5 9.4A2.4 2.4 0 0 1 5.9 7h1.5l1.2-2h6.8l1.2 2h1.5A2.4 2.4 0 0 1 20.5 9.4v7.2A2.4 2.4 0 0 1 18.1 19H5.9a2.4 2.4 0 0 1-2.4-2.4V9.4Z" />
        <circle cx="12" cy="13" r="3.2" />
    </Icon>
)

/* TRASH ICON — AVATAR REMOVE */
export const TrashIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <path d="M4.5 7h15" />
        <path d="M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" />
        <path d="M6.5 7l.8 11.2A1.9 1.9 0 0 0 9.2 20h5.6a1.9 1.9 0 0 0 1.9-1.8L17.5 7" />
    </Icon>
)

/* PENCIL ICON — EDIT A ROW */
export const EditIcon = ({ size = 16 }) => (
    <Icon size={size} width={1.9}>
        <path d="M11 4.5H7A2.5 2.5 0 0 0 4.5 7v10A2.5 2.5 0 0 0 7 19.5h10a2.5 2.5 0 0 0 2.5-2.5v-4" />
        <path d="M18.4 3.1a2 2 0 0 1 2.8 2.8L12.4 14.7l-3.6.9.9-3.6Z" />
    </Icon>
)

/* STAR ICON — A SAVED ROUND, IT IS FILLED WHILE THE FILTER IS ON */
export const StarIcon = ({ size = 14, filled = false }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3.3l2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.8-5.4 2.8 1-6L3.2 9.7l6.1-.9Z" />
    </svg>
)

/* PLUS ICON — ADD A ROW */
export const PlusIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.4}>
        <path d="M12 5.5v13M5.5 12h13" />
    </Icon>
)

/* MAIL ICON — EMAIL */
export const MailIcon = ({ size = 15 }) => (
    <Icon size={size} width={1.9}>
        <rect x="3" y="5.5" width="18" height="13" rx="2.4" />
        <path d="M3.8 7.2 12 13l8.2-5.8" />
    </Icon>
)

/* MONITOR ICON — A DESKTOP SESSION */
export const MonitorIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <rect x="3" y="4.5" width="18" height="12" rx="2.2" />
        <path d="M9 20h6M12 16.5V20" />
    </Icon>
)

/* PHONE ICON — A MOBILE SESSION */
export const PhoneIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <rect x="6.5" y="2.8" width="11" height="18.4" rx="2.6" />
        <path d="M10.8 5.6h2.4M12 18.2h.01" />
    </Icon>
)

/* EYE ICON — A HIDDEN PASSWORD */
export const EyeIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <path d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12S18 18.2 12 18.2 2.5 12 2.5 12Z" />
        <circle cx="12" cy="12" r="3.1" />
    </Icon>
)

/* EYE OFF ICON — A VISIBLE PASSWORD */
export const EyeOffIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <path d="M9.6 6.2A8.6 8.6 0 0 1 12 5.8c6 0 9.5 6.2 9.5 6.2a17 17 0 0 1-2.6 3.4" />
        <path d="M6.2 8A17.4 17.4 0 0 0 2.5 12S6 18.2 12 18.2c1.4 0 2.6-.3 3.7-.8" />
        <path d="M9.9 9.9a3.1 3.1 0 0 0 4.2 4.2" />
        <path d="M3.5 3.5l17 17" />
    </Icon>
)

/* PAUSE ICON — A PAUSED GAME */
export const PauseIcon = ({ size = 18 }) => (
    <Icon size={size} width={1.9}>
        <rect x="6.6" y="4.6" width="4" height="14.8" rx="1.6" />
        <rect x="13.4" y="4.6" width="4" height="14.8" rx="1.6" />
    </Icon>
)

/* INBOX ICON — AN EMPTY NOTIFICATION LIST */
export const InboxIcon = ({ size = 28 }) => (
    <Icon size={size} width={1.8}>
        <path d="M3.4 13.6 6 5.6A2.2 2.2 0 0 1 8.1 4h7.8a2.2 2.2 0 0 1 2.1 1.6l2.6 8" />
        <path d="M3.4 13.6h4.7l1.2 2.5h5.4l1.2-2.5h4.7v4.2A2.2 2.2 0 0 1 18.4 20H5.6a2.2 2.2 0 0 1-2.2-2.2v-4.2Z" />
    </Icon>
)

/* DOUBLE CHECK ICON — READ EVERYTHING */
export const CheckAllIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.3}>
        <path d="M1.8 12.6 5.6 16.4 12.6 8.2" />
        <path d="M10 16.4 11.6 18 22.2 6.4" />
    </Icon>
)

/* ARROW ICON — OPEN THE TABLE */
export const ArrowUpRightIcon = ({ size = 14 }) => (
    <Icon size={size} width={2.4}>
        <path d="M7 17 17 7" />
        <path d="M8.6 7H17v8.4" />
    </Icon>
)

/* DOTS ICON — THE REST OF THE MENU ON A PHONE */
export const DotsIcon = ({ size = 18 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" stroke="none">
        <circle cx="5.5" cy="12" r="1.9" />
        <circle cx="12" cy="12" r="1.9" />
        <circle cx="18.5" cy="12" r="1.9" />
    </svg>
)

/* PIN ICON — COUNTRY AND CITY */
export const PinIcon = ({ size = 14 }) => (
    <Icon size={size} width={2}>
        <path d="M12 21s6.5-5.6 6.5-10.4A6.5 6.5 0 0 0 5.5 10.6C5.5 15.4 12 21 12 21Z" />
        <circle cx="12" cy="10.4" r="2.4" />
    </Icon>
)


/* GAME ICONS — THE PANELS, THE ROUNDS AND THE MONEY OF A TABLE */

/* FILTER ICON — THE PERIOD, THE STATUS AND THE OPERATORS OF THE LIST */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* RELOAD ICON — THE LIST IS READ AGAIN */
export const ReloadIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M20 12a8 8 0 1 1-2.4-5.7" />
        <path d="M20 4v5h-5" />
    </Icon>
)

/* COPY ICON — THE NUMBER OF A ROUND GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* SPADE ICON — THE ELECTRON GAME ITSELF */
export const SpadeIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <path d="M12 3.5c-2 2.8-7 5.4-7 9a3.8 3.8 0 0 0 6.4 2.8" />
        <path d="M12 3.5c2 2.8 7 5.4 7 9a3.8 3.8 0 0 1-6.4 2.8" />
        <path d="M12 13.5v7M9.5 20.5h5" />
    </Icon>
)

/* HASH ICON — THE NUMBER OF A ROUND */
export const HashIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4 8.5h16M3 15.5h16" />
    </Icon>
)

/* PLAYER ICON */
export const PlayerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="8" r="3.8" />
        <path d="M4.8 20c0-3.6 3.2-5.8 7.2-5.8s7.2 2.2 7.2 5.8" />
    </Icon>
)

/* PLAYERS ICON — HOW MANY PEOPLE STAND BEHIND THE ROUNDS */
export const PlayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.6" />
        <path d="M2.8 19.5c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M18 14.7c2.1.6 3.4 2.2 3.4 4.3" />
    </Icon>
)

/* OPERATOR ICON */
export const OperatorIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20.5V6.5A2 2 0 0 1 6 4.5h6a2 2 0 0 1 2 2v14" />
        <path d="M14 10.5h4a2 2 0 0 1 2 2v8" />
        <path d="M2.5 20.5h19M7.5 8.5h3M7.5 12.5h3M7.5 16.5h3" />
    </Icon>
)

/* TABLE ICON — THE GAME BEHIND A ROUND */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* LAYERS ICON — HOW MANY ROUNDS THE FILTER HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* FLAG ICON — THE STATUS OF A ROUND */
export const FlagIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M5 21V4.5" />
        <path d="M5 5.2h12l-2.4 3.9L17 13H5Z" />
    </Icon>
)

/* PLAY ICON — A ROUND THAT IS STILL RUNNING */
export const PlayIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M10.2 9.2 15 12l-4.8 2.8Z" />
    </Icon>
)

/* CHECK CIRCLE ICON — A ROUND THAT IS OVER */
export const DoneIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M8.5 12.3 11 14.8l4.5-5" />
    </Icon>
)

/* CALENDAR ICON — THE PERIOD OF THE LIST */
export const CalendarIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* WALLET ICON */
export const WalletIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3.5 7.5A2.5 2.5 0 0 1 6 5h11.5A2.5 2.5 0 0 1 20 7.5v9a2.5 2.5 0 0 1-2.5 2.5H6a2.5 2.5 0 0 1-2.5-2.5Z" />
        <path d="M3.5 9.5h13a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-13" />
        <path d="M15.4 12h.2" />
    </Icon>
)

/* DEBIT ICON — THE MONEY LEFT THE PLAYER */
export const DebitIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 4.5v13" />
        <path d="M7 12.5 12 17.5 17 12.5" />
    </Icon>
)

/* CREDIT ICON — THE MONEY CAME BACK TO THE PLAYER */
export const CreditIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 19.5v-13" />
        <path d="M7 11.5 12 6.5 17 11.5" />
    </Icon>
)

/* NET ICON — THE DIFFERENCE BETWEEN THE TWO */
export const NetIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3.5 17.5 9 11l4 4 7.5-8.5" />
        <path d="M15.5 6.5h5v5" />
    </Icon>
)

/* BALANCE ICON — THE WALLET OF THE PLAYER BEFORE AND AFTER */
export const BalanceIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 4.5v15" />
        <path d="M6.5 8.5h8a2.5 2.5 0 0 1 0 5h-5a2.5 2.5 0 0 0 0 5h8" />
    </Icon>
)

/* REFUND ICON — THE MONEY WENT BACK */
export const RefundIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 9.5h10.5a4.5 4.5 0 0 1 0 9H9" />
        <path d="M7.5 6 4 9.5 7.5 13" />
    </Icon>
)

/* PAY ICON — THE MONEY GOES TO THE PLAYER */
export const PayIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5v9M9.5 10.2h4a1.8 1.8 0 0 1 0 3.6h-3a1.8 1.8 0 0 0 0 3.6h4" />
    </Icon>
)

/* CHIP ICON — THE BETS OF A ROUND */
export const ChipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="3.6" />
        <path d="M12 3.5v2.2M12 18.3v2.2M3.5 12h2.2M18.3 12h2.2" />
    </Icon>
)

/* CARDS ICON — THE CARDS OF A ROUND */
export const CardsIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="9" y="4" width="11" height="15" rx="2.5" />
        <path d="M6 6.5 4.2 17.2a2 2 0 0 0 1.6 2.3l7 1.2" />
    </Icon>
)

/* CHART ICON — THE STATISTICS OF THE GAME */
export const ChartIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3.5 20.5h17" />
        <path d="M7 20.5V11M12 20.5V4.5M17 20.5v-6" />
    </Icon>
)

/* CURRENCY ICON — THE LIMITS OF THE GAME */
export const CurrencyIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M14.5 9.2A3 3 0 0 0 12 8c-1.7 0-2.8.9-2.8 2s.9 1.8 2.8 2 2.8.9 2.8 2-1.1 2-2.8 2a3 3 0 0 1-2.5-1.2" />
        <path d="M12 6.2v11.6" />
    </Icon>
)

/* SETTINGS ICON — THE PARAMETERS OF THE GAME */
export const SettingsIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="3.2" />
        <path d="M19.4 14.5a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1v.3a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-2.8-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7h-.3a2 2 0 1 1 0-4h.2a1.6 1.6 0 0 0 1.1-2.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1v-.3a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 2.8 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7h.3a2 2 0 1 1 0 4h-.2a1.6 1.6 0 0 0-1.4.9Z" />
    </Icon>
)

/* SLIDERS ICON — THE PARAMETERS OF THE TABLE */
export const SlidersIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M4 6.5h9M17.5 6.5H20M4 17.5h3M11.5 17.5H20M4 12h13M21 12h-1" />
        <circle cx="15" cy="6.5" r="2.2" />
        <circle cx="9" cy="17.5" r="2.2" />
        <circle cx="19" cy="12" r="2.2" />
    </Icon>
)

/* CHAT ICON — THE MESSAGES OF THE TABLE */
export const ChatIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M20.5 12.2c0 4-3.8 7.2-8.5 7.2a10 10 0 0 1-2.6-.3L4 20.5l1.3-3.4A6.9 6.9 0 0 1 3.5 12.2C3.5 8.2 7.3 5 12 5s8.5 3.2 8.5 7.2Z" />
        <path d="M8.5 12h.1M12 12h.1M15.5 12h.1" />
    </Icon>
)

/* DEALER ICON — THE CROUPIERS ALLOWED ON THE TABLE */
export const DealerIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="7.2" r="3.4" />
        <path d="M5 20.5c0-3.7 3.1-6.3 7-6.3s7 2.6 7 6.3" />
        <path d="M9.2 20.5v-2.8M14.8 20.5v-2.8" />
    </Icon>
)

/* VIDEO ICON — THE ARCHIVE OF THE STUDIO */
export const VideoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <rect x="2.5" y="6" width="13" height="12" rx="3" />
        <path d="M15.5 10.5 21.5 7.5v9l-6-3Z" />
    </Icon>
)

/* ARROW ICON — THE ROUND OF THE LIST OPENS */
export const ArrowIcon = ({ size = 13 }) => (
    <Icon size={size} width={2.4}>
        <path d="M9 5.5 15.5 12 9 18.5" />
    </Icon>
)

/* STOP ICON — THE ROUND IS CLOSED BY THE ADMIN */
export const StopIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <rect x="9" y="9" width="6" height="6" rx="1.5" />
    </Icon>
)

/* SIGNAL ICON — THE SOCKET OF THE GAME SERVER */
export const SignalIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M5.5 15.5a6 6 0 0 1 0-8.5M18.5 7a6 6 0 0 1 0 8.5" />
        <path d="M8.4 12.8a2.5 2.5 0 0 1 0-2.8M15.6 10a2.5 2.5 0 0 1 0 2.8" />
        <circle cx="12" cy="11.4" r="1.4" />
        <path d="M12 13v7" />
    </Icon>
)

/* NOTE ICON — WHAT THE ADMINS WROTE ABOUT THE ROUND */
export const NoteIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M5 5.5A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5v13A2.5 2.5 0 0 1 16.5 21h-9A2.5 2.5 0 0 1 5 18.5Z" />
        <path d="M8.5 8h7M8.5 12h7M8.5 16h4" />
    </Icon>
)

/* TAG ICON — THE ROUND ID THE OPERATOR KNOWS THE ROUND BY */
export const TagIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M11.6 3.5H5.5A2 2 0 0 0 3.5 5.5v6.1a2 2 0 0 0 .6 1.4l7.4 7.4a2 2 0 0 0 2.8 0l6.1-6.1a2 2 0 0 0 0-2.8L13 4.1a2 2 0 0 0-1.4-.6Z" />
        <path d="M7.6 7.6h.01" />
    </Icon>
)

/* WHEEL ICON — THE WINNING NUMBER OF THE ROULETTE */
export const WheelIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="2.4" />
        <path d="M12 3.5v6.1M12 14.4v6.1M3.5 12h6.1M14.4 12h6.1" />
    </Icon>
)

/* ROTATE ICON — THE CARDS OF THE ROUND ARE SCANNED AGAIN */
export const RotateIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M20 12a8 8 0 1 1-2.6-5.9" />
        <path d="M20 4v4.5h-4.5" />
    </Icon>
)

/* TROPHY ICON — THE SIDE THAT TOOK THE ROUND */
export const TrophyIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M8 4h8v5a4 4 0 0 1-8 0Z" />
        <path d="M8 5.5H5.5v1.2A3.3 3.3 0 0 0 8.4 10M16 5.5h2.5v1.2A3.3 3.3 0 0 1 15.6 10" />
        <path d="M12 13v3.5M8.5 20.5h7M9.8 20.5c0-2.2 1-4 2.2-4s2.2 1.8 2.2 4" />
    </Icon>
)

/* RECEIPT ICON — THE TRANSACTIONS OF THE ROUND */
export const ReceiptIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M6 3.5h12v17l-3-1.6-3 1.6-3-1.6-3 1.6Z" />
        <path d="M9 8h6M9 12h6" />
    </Icon>
)

/* BETS ICON — HOW MANY BETS THE PLAYER PUT IN THE ROUND */
export const BetsIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <ellipse cx="12" cy="6.5" rx="7.5" ry="3" />
        <path d="M4.5 6.5v5c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3v-5" />
        <path d="M4.5 11.5v5c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3v-5" />
    </Icon>
)

/* ARROW RIGHT ICON — THE BALANCE BEFORE TURNS INTO THE BALANCE AFTER */
export const ArrowRightIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 12h16M14.5 6.5 20 12l-5.5 5.5" />
    </Icon>
)

/* ADMIN ICON — WHO OF THE PANEL RAN THE OPERATION */
export const AdminIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3.5 5 6v5.4c0 4 2.8 7.6 7 9.1 4.2-1.5 7-5.1 7-9.1V6Z" />
        <path d="M9.2 12.2 11.3 14.3 15 10.6" />
    </Icon>
)

/* HOURGLASS ICON — THE REQUEST NEVER CAME BACK */
export const HourglassIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M7 3.5h10M7 20.5h10" />
        <path d="M8 3.5v3.2c0 1.4 4 3.9 4 5.3 0 1.4-4 3.9-4 5.3v3.2M16 3.5v3.2c0 1.4-4 3.9-4 5.3 0 1.4 4 3.9 4 5.3v3.2" />
    </Icon>
)

/* HAND ICON — THE HAND OR THE BOX OF THE PLAYER */
export const HandIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M8.5 11V5.5a1.8 1.8 0 0 1 3.6 0V11" />
        <path d="M12.1 11V6.8a1.8 1.8 0 0 1 3.6 0V12" />
        <path d="M15.7 12v-1.2a1.8 1.8 0 0 1 3.6 0V15a5.5 5.5 0 0 1-5.5 5.5h-1.9a5.5 5.5 0 0 1-4.7-2.6L4.9 14a1.8 1.8 0 0 1 3-2l.6.9" />
    </Icon>
)
